import { ReactNode, useEffect, useState } from 'react';
import useExternalSearch from '~/apps/smartsend/components/smartsend/client/useExternalSearch';

interface props {
  children: ReactNode;
}

export default function SearchInitialiser({ children }: props) {
  const [loading, setLoading] = useState(true);
  const { getExternalSearchCredentials } = useExternalSearch();
  useEffect(() => {
    const load = async () => {
      await getExternalSearchCredentials();
      setLoading(false);
    };
    load();
  }, []);

  if (loading) {
    return null;
  }

  return <>{children}</>;
}
